export default __webpack_public_path__ + "static/media/Mail.be05af82.svg";